var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"empty:hidden"},[(_vm.data.length && _vm.remoteDatasetLoaded)?_c('LegalEntityList',{attrs:{"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }